module.exports = __webpack_public_path__ + "img/template_d.3613d6b5.svg";